export const SORT_URL_CATEGORY_RANKING = 'categoryRanking' as const;
export const SORT_URL_PURCHASE_FREQUENCY = 'weightedFavourites' as const;
